module.exports = __webpack_public_path__ + "static/radicle-logo@2x-7be9f8810fbfe5b1147ca85a09d09de4.png";